<template>
    <b-table style="margin-top: 10px" id="table_participants" responsive small hover :tbody-tr-class="row_femme"
        :items="participants.list_participants" :fields="fields" :per-page="perPage" @row-clicked="openFicheCoureur">
        <template #head(classement)>
            <b-button style="white-space: nowrap" size="sm" class="live_filter_btn_header_row"
                v-on:click="setSortby('clt')" v-bind:class="{ sex_selected_button: sortby === 'clt' }"> <b-icon
                    icon="sort-numeric-down"></b-icon> {{
                        $t("clt") }} </b-button>
        </template>
        <template #head(nom)>
            <b-button style="white-space: nowrap" size="sm" class="live_filter_btn_header_row"
                v-on:click="setSortby('name')" v-bind:class="{ sex_selected_button: sortby === 'name' }"> <b-icon
                    icon="sort-alpha-down"></b-icon> {{
                        $t("nom") }} </b-button>
        </template>
        <template #head(itra)>
            <p style="min-width: 80px">
                <b-button style="white-space: nowrap; height: 100% !important" size="sm"
                    class="live_filter_btn_header_row itra_filter_btn" v-on:click="setSortby('itra')"
                    v-bind:class="{ sex_selected_button: sortby === 'itra' }">
                    <b-icon icon="sort-numeric-down"></b-icon> <img src="../../../assets/Logo_itra_Simple_N blanc.png"
                        alt="itra" class="itra_logo_filter" />
                </b-button>
            </p>
        </template>
        <template #cell(classement)="row">
            <span v-if="row.item.classement != 100000">{{ row.item.classement }}</span>
            <span v-else>-</span>
        </template>

        <template #cell(classement_cat)="row">
            <span v-if="row.item.classement_cat != 100000">{{ row.item.classement_cat }}{{ row.item.cat }}</span>
            <span v-else>-</span>
        </template>
        <template #cell(classement_sexe)="row">
            <span v-if="row.item.classement_sexe != 100000">{{ row.item.classement_sexe }}{{ row.item.sexe }}</span>
            <span v-else>-</span>
        </template>
        <template #cell(itra)="row">
            <span v-if="row.item.itra > 0">{{ row.item.itra }}</span>
            <span v-else>-</span>
        </template>
        <template #cell(club)="row">
            <span v-if="row.item.club != ''">{{ truncatedClub(row.item.club) }}</span>
            <span v-else>-</span>
        </template>
        <template #cell(sexe)="row">
            <p class="sexe-icon-male" v-if="row.item.sexe === 'M'">M</p>
            <p class="sexe-icon-female" v-else-if="row.item.sexe === 'F'">F</p>
            <p class="sexe-icon-mixte" v-else>M/F</p>
        </template>
        <template #cell(nom)="row">
            <span><img class="flag" :src="'https://sportips.fr/live/img/Flags/' + row.item.nation + '.jpg'" />{{
                row.item.nom }} {{ row.item.prenom }}</span>
        </template>
        <template #cell(heure_depart_coureur)="row">
            <p>
                <span v-if="row.item.heure_depart_coureur != ''">{{ row.item.heure_depart_coureur }}</span><span
                    v-else>-</span>
            </p>
        </template>
        <template #cell(abandon)="row">
            <b-form-checkbox size="sm" v-model="row.item.abandon" @change="changeCoureurAbandon(row.item)" value="O"
                unchecked-value="N"></b-form-checkbox>
        </template>
        <template #cell(disqualifie)="row">
            <b-form-checkbox size="sm" v-model="row.item.disqualifie" @change="changeCoureurDisqualifie(row.item)"
                value="O" unchecked-value="N"></b-form-checkbox>
        </template>
        <template #cell(statut)="row">
            <div class="live_status">
                <p v-if="row.item.statut.text.includes('Arrivé')" class="text-nowrap status_arrive">
                    <v-icon name="check" />
                    {{ get_translated_status(row.item.statut.text) }}
                </p>
                <p v-else-if="row.item.statut.text.includes('Abandon') || row.item.statut.text.includes('Disqualifié') || row.item.statut.text.includes('Non parti')"
                    class="text-nowrap status_abandon">
                    <v-icon name="times" />
                    {{ get_translated_status(row.item.statut.text) }}
                </p>
                <p v-else class="text-nowrap status_autre">
                    {{ get_translated_status(row.item.statut.text) }}
                </p>
            </div>
        </template>
    </b-table>
</template>

<script>
export default {
    computed: {
        participants() {
            return this.$store.getters["listCoureurs/participants"];
        },
        fields() {
            return this.$store.getters["listCoureurs/fields"];
        },
        sortby() {
            return this.$store.getters["listCoureurs/sortby"];
        },
        perPage() {
            return this.$store.getters["listCoureurs/perPage"];
        }
    },
    methods: {
        truncatedClub(club) {
            if (club.length > 25) {
                return club.substring(0, 25) + "...";
            }
            return club;
        },
        setSortby(sortby) {
            this.$store.commit("listCoureurs/setSortby", sortby);
        },
        get_translated_status(status) {
            // Ligne de statut retourné par le serveur en francais, traduit si langue locale = UK
            var translated = status;
            translated = translated.replace("Arrivée en", this.$t("arrivee_en"));
            translated = translated.replace("A l'entrainement", this.$t("entrainement"));
            translated = translated.replace("Non parti", this.$t("non_parti"));
            translated = translated.replace("Abandon", this.$t("abandon"));
            translated = translated.replace("Disqualifié", this.$t("disqualifie"));
            translated = translated.replace("A l'échauffement", this.$t("echauffement"));
            return translated;
        },
        row_femme(item, type) {
            if (!item || type !== "row") return;
            if (item.sexe === "F") return "row-femme";
        },
        openFicheCoureur(item, index) {
            var fiche_path = "fiche/" + item.id;
            this.$router.push({ path: fiche_path });
        },
        changeCoureurAbandon(coureur) {
            this.$store.dispatch("listCoureurs/changeCoureurAbandon", coureur);
        },
        changeCoureurDisqualifie(coureur) {
            this.$store.dispatch("listCoureurs/changeCoureurDisqualifie", coureur);
        }
    }
}
</script>

<style lang="scss" scoped></style>